import { useDisclosure } from "@heroui/react";
import { InputField, ModalBuilder, ModalError } from "../modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";

interface ICreateAccountingIntegrationForm {
  displayName: string;
  instanceUrl: string;
  username: string;
  password: string;
  enabled: boolean;
  businessRequisiteId: number;
}

const createAccountingIntegrationFields: InputField[] = [
  {
    label: "Название",
    name: "displayName",
    placeholder: "Моя интеграция",
    type: "text",
    isRequired: true,
  },
  {
    label: "URL инстанса",
    name: "instanceUrl",
    placeholder: "https://example.com",
    type: "text",
    isRequired: true,
  },
  {
    label: "Пользователь",
    name: "username",
    placeholder: "admin",
    type: "text",
    isRequired: true,
  },
  {
    label: "Пароль",
    name: "password",
    placeholder: "••••••••",
    type: "password",
    isRequired: true,
  },
  {
    label: "Активна",
    name: "enabled",
    placeholder: "",
    type: "boolean",
  },
  {
    label: "Реквизиты",
    name: "businessRequisiteId",
    placeholder: "",
    type: "requisites",
    isRequired: true,
  },
];

export function CreateAccountingIntegrationModal({
  disclosure,
  onCreated,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  onCreated?: () => void;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErrors] = useState<ModalError[]>([]);

  const handleError = useErrorHandling();

  const onSubmit = (data: ICreateAccountingIntegrationForm) => {
    return new Promise<boolean>(async (resolve) => {
      api.accountingIntegrations
        .create({
          displayName: data.displayName,
          instanceUrl: data.instanceUrl,
          username: data.username,
          password: data.password,
          enabled: data.enabled ?? false,
          businessRequisiteId: Number(data.businessRequisiteId),
        })
        .then(() => {
          toast.success("Интеграция успешно создана");
          disclosure.onClose();
          onCreated?.();
          resolve(true);
        })
        .catch((err) => {
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErrors(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Создание интеграции"
      modalErrors={modalErrors}
      fields={createAccountingIntegrationFields}
      isOpen={isOpen}
      isSensitiveData={false}
      onOpenChange={onOpenChange}
      onSubmit={onSubmit}
    />
  );
}
